import React, { useRef, useState, useEffect } from "react";
import {
	FormControl,
	InputAdornment,
	Stack,
	CircularProgress
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";

import Styled from "../Styled";
import SearchResults from "./SearchResults";
import { searchBiddableProducts } from "src/redux/actions/products";

const Search = ({ lgScreen }) => {
	const [triggerSearch, setTriggerSearch] = useState(false);
	const [searchTxt, setSearchTxt] = useState("");
	const [searchedProducts, setSearchedProducts] = useState([]);
	const searchInpPointer = useRef(null);
	const {
		products: searchResp,
		loading: searchLoading,
		err: searchError
	} = useSelector(state => state.searchBiddableProducts);
	const dispatch = useDispatch();

	useEffect(() => {
		if (searchResp) {
			setSearchedProducts(searchResp);
		}
	}, [searchResp]);

	const onSearchClick = () => {
		if (!searchTxt?.length) return;
		dispatch(searchBiddableProducts(searchTxt));
		setTriggerSearch(prev => !prev);
		document.body.classList.toggle("on-modal-dialog", true);
		// console.log("searchInpPointer", searchInpPointer);
		// searchInpPointer?.current?.blur();
	};
	const onKeyPressed = e => {
		// Enter key code == 13
		if (e.keyCode !== 13) return;
		onSearchClick();
	};
	const onCloseSearchBoard = () => {
		setTriggerSearch(false);
		document.body.classList.toggle("on-modal-dialog", false);
	};
	// useEffect(() => {
	// 	SetUpSearch();
	// }, []);
	return (
		<Stack
			alignItems="center"
			direction="row"
			sx={theme => ({
				[theme.breakpoints.up("md")]: { marginInline: "auto" },
				[theme.breakpoints.down("md")]: { justifyContent: "center" }
			})}
		>
			<FormControl>
				{lgScreen ? (
					<Styled.SearchInput
						color="secondary"
						placeholder="Search inventory by category, name and more..."
						disableUnderline={true}
						ref={searchInpPointer}
						value={searchTxt}
						onChange={e => setSearchTxt(e.target.value)}
						onKeyDown={e => onKeyPressed(e)}
						startAdornment={
							<InputAdornment position="start">
								<SearchIcon />
							</InputAdornment>
						}
					/>
				) : (
					<Styled.SearchInput
						color="secondary"
						placeholder="Search by brand, name and more..."
						smscreen="1"
						disableUnderline={true}
						ref={searchInpPointer}
						value={searchTxt}
						onChange={e => setSearchTxt(e.target.value)}
						onKeyDown={e => onKeyPressed(e)}
						sx={{ pl: 1 }}
					/>
				)}
			</FormControl>

			{triggerSearch && (
				<SearchResults
					results={searchedProducts}
					onCloseSearchBoard={onCloseSearchBoard}
					loading={searchLoading}
					error={searchError}
				/>
			)}

			<Styled.Btn
				search="1"
				color="secondary"
				variant="contained"
				sx={theme => ({ [theme.breakpoints.down("md")]: { minWidth: 54 } })}
				onClick={onSearchClick}
				disabled={searchLoading}
			>
				{searchLoading ? (
					<CircularProgress size={30} />
				) : lgScreen ? (
					"Search Inventory"
				) : (
					<SearchIcon />
				)}
			</Styled.Btn>
		</Stack>
	);
};

export default React.memo(Search);
